// extracted by mini-css-extract-plugin
module.exports = {"settings":"styles_settings__mUgJj","settings__button":"styles_settings__button__25hZe","settings__img":"styles_settings__img__1BYrl","close":"styles_close__2Sagi"};